export default __webpack_public_path__ + "static/media/webshop.6a279cbf.svg";